<template>

  <div class='card'>

    <div class='card-image'>
      <img :src="image" />
    </div>
    <div class='card-content'>
      <h3 class='card-title'> {{ title }} </h3>
      <p> {{ description }}
        <div v-if="learnMoreLink != ''"><a :href="learnMoreLink"> Learn More </a></div>
      </p>
      
    </div>
    <div class='chips-container'>
      <p v-if="cleanCategories.length > 0"> <span class='bold'> Category: </span> 
        <span v-for="(category, index) in cleanCategories" :key="'category-' + index"> {{ category }} <span v-if="index < cleanCategories.length - 1">, </span></span>
      </p>
      <p v-if="cleanPlatforms.length > 0"> <span class='bold'> Platform: </span> 
        <span v-for="(platform, index) in cleanPlatforms" :key="'platform-' + index"> {{platform}} <span v-if="index < cleanPlatforms.length - 1">, </span> </span>
      </p>
      <p v-if="cleanAges.length > 0"> 
        <span class='bold'> Grade Level: </span> 
        <span v-for="(age, index) in cleanAges" :key="'age-' + index"> {{age}} <span v-if="index < cleanAges.length - 1">, </span></span>
      
      <div v-if="requirements != ''"> 
        <p class='red-text'> 
          <span v-for="(requirement, index) in requirements" :key="'requirement-' + index"> {{requirement}}<span v-if="index < requirements.length - 1">, </span></span>
        </p>
      </div>
      
      <div v-if="warnings != ''"> 
        <p> <span class='red-text'> {{warnings}} </span> </p> 
      </div>

    </div>
    <div class='card-action'>
      <a :href="button1url" class='btn' v-if="button1text != '' && button1url != ''" > {{button1text}} </a>
      <a :href="button2url" class='btn' v-if="button2text != '' && button2url != ''" style='float: right;'> {{button2text}} </a>
    </div>

  </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: "Resource",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    categories: {
      type: Array,
      default: function () {
        return [];
      },
    },
    permissions: {
      type: String,
      default: "",
    },
    requirements: {
      type: Array,
      default: function () {
        return [];
      },
    },
    warnings: {
      typs: String,
      default: "",
    },
    platforms: {
      type: Array,
      default: function () {
        return [];
      },
    },
    ages: {
      type: Array,
      default: function () {
        return [];
      },
    },
    image: {
      type: String,
      default: "",
    },
    button1text: {
      type: String,
      default: "",
    },
    button1url: {
      type: String,
      default: "",
    },
    button2text: {
      type: String,
      default: "",
    },
    button2url: {
      type: String,
      default: "",
    },
    learnMoreLink: {
      type: String,
      default: "",
    },
  },
  methods: {
    categoryUrl: function (category) {
      var formattedCategory = "";
      var excludes = ["&", ",", "(", ")"];
      var delimiters = ["/", " "];

      category = category.trim();

      for (var i = 0; i < category.length; i++) {
        if (excludes.includes(category[i])) {
          continue;
        } else if (delimiters.includes(category[i])) {
          formattedCategory += "-";
        } else {
          formattedCategory += category[i];
        }
      }
      return "/category/" + formattedCategory;
    },
  },
  computed: {
    cleanCategories: function () {
      return this.categories.filter((x) => {
        return x != "";
      });
    },
    cleanPlatforms: function () {
      return this.platforms.filter((x) => {
        return x != "";
      });
    },
    cleanAges: function () {
      return this.ages.filter((x) => {
        return x != "";
      });
    },
  },
};
</script>

<style scoped>
.chips-container {
  padding: 0px 24px 10px 24px;
}

.chips-container > p:first-of-type {
  margin-top: 0px;
}
/* .card-action {
    position: absolute;
  } */
</style>